<section class="page-header">
  <div class="page-header__title">
    <img src="assets/imgs/logo-evento.png" alt="Logo del evento">
    <h1><span i18n="@@web-inscripciones.inscripciones">Inscripciones {{event_name}} {{event_year}}</span></h1>
    <img src="assets/imgs/logo-collegi.png" alt="El Col·legi">
  </div>
  <div class="page-header__idioma">
    <cambio-idioma></cambio-idioma>
  </div>  
</section>

<section class="page-body">
  <form [formGroup]="form_inscripcion" class="full-width">
    <ul>
      <li class="radio-buttons" formGroupName="dni_validation_group">
        <mat-label><strong i18n="@@web-inscripciones.seleccione-el-tipo-de-inscripcion">Seleccione el tipo de inscripción:</strong></mat-label>
        <mat-radio-group color="primary" class="tipo-inscripcion-radio-group" formControlName="tipo_inscripcion">
          <mat-radio-button class="tipo-inscripcion-radio-button" value="2">
            <span i18n="@@web-inscripciones.mediador-no-colegiado">Mediador no colegiado</span>
          </mat-radio-button>
          <mat-radio-button class="tipo-inscripcion-radio-button" value="1">
            <span i18n="@@web-inscripciones.mediador-colegiado">Mediador Colegiado</span>
          </mat-radio-button>
          <mat-radio-button class="tipo-inscripcion-radio-button" value="3">
            <span i18n="@@web-inscripciones.profesional-compania-aseguradora">Profesional de compañía aseguradora</span>
          </mat-radio-button>
          <mat-radio-button class="tipo-inscripcion-radio-button" value="4">
            <span i18n="@@web-inscripciones.otro-profesional">Otro profesional</span>
          </mat-radio-button>
        </mat-radio-group>
      </li>

      <li class="double">
        <mat-form-field class="form-control" cdkFocusInitial formGroupName="dni_validation_group">
          <mat-label><span i18n="@@dni">DNI</span></mat-label>
          <input matInput type="text" formControlName="dni" uppercase>
          
          @if (form_inscripcion.get('dni_validation_group')?.errors?.required) {
            <mat-hint class="error-text" i18n="@@web-inscripciones.introduzca-su-dni">Introduzca su DNI</mat-hint>
          }
          @if (form_inscripcion.get('dni_validation_group')?.errors?.DNIDuplicate) {
            <mat-hint class="error-text" i18n="@@web-inscripciones.dni-ya-existente">DNI ya existente (¿Invitado duplicado?)</mat-hint>
          }
          @if (form_inscripcion.get('dni_validation_group')?.errors?.DNIExiste) {
            <mat-hint class="error-text" i18n="@@web-inscripciones.dni-ya-registrado">DNI ya registrado</mat-hint>
          }
          @if (form_inscripcion.get('dni_validation_group')?.errors?.noMediador) {
            <mat-hint class="error-text" i18n="@@web-inscripciones.dni-no-pertenece-a-un-mediador">DNI no pertenece a un mediador</mat-hint>
          }
        </mat-form-field>
      </li>

      <!-- Datos Personales -->
      <li>
        <mat-form-field class="form-control">
          <mat-label i18n="@@nombre">Nombre</mat-label>
          <input matInput type="text" formControlName="nombre">
          @if (form_inscripcion.controls.nombre.touched && form_inscripcion.controls.nombre.invalid) {
            <mat-hint class="error-text" i18n="@@web-inscripciones.introduzca-su-nombre">Introduzca su nombre</mat-hint>
          }
        </mat-form-field>
      </li>

      <li class="double">
        <mat-form-field class="form-control">
          <mat-label i18n="@@apellido1">Apellido 1</mat-label>
          <input matInput type="text" formControlName="apellido1">
        </mat-form-field>
        <mat-form-field class="form-control">
          <mat-label i18n="@@apellido2">Apellido 2</mat-label>
          <input matInput type="text" formControlName="apellido2">
        </mat-form-field>
      </li>

      <li class="double">
        <mat-form-field class="form-control">
          <mat-label i18n="@@email">Email</mat-label>
          <input matInput type="email" formControlName="email">
        </mat-form-field>
        <mat-form-field class="form-control">
          <mat-label i18n="@@telefono">Teléfono</mat-label>
          <input matInput type="text" formControlName="telefono">
        </mat-form-field>
      </li>

      <!-- Ubicación y Empresa -->
      <li>
        <mat-form-field class="form-control">
          <mat-label i18n="@@direccion">Dirección</mat-label>
          <input matInput type="text" formControlName="direccion">
        </mat-form-field>
      </li>

      <li class="double">
        <mat-form-field class="form-control" style="width:10em;">
          <mat-label i18n="@@codigo-postal">Código Postal</mat-label>
          <input matInput type="text" formControlName="codigo_postal">
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label i18n="@@ciudad">Ciudad</mat-label>
          <input matInput type="text" formControlName="ciudad">
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label i18n>País</mat-label>
          <input matInput type="text" formControlName="pais">
        </mat-form-field>
      </li>

      <li class="double">
        <mat-form-field class="form-control" style="width:10em;">
          <mat-label i18n="@@tipo-empresa">Tipo empresa</mat-label>
          <input matInput type="text" formControlName="tipo_empresa">
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label i18n="@@empresa">Empresa</mat-label>
          <input matInput type="text" formControlName="empresa">
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label i18n="@@cargo">Cargo</mat-label>
          <input matInput type="text" formControlName="cargo">
        </mat-form-field>
      </li>
    </ul>
  </form>

  <!-- Listado de Invitados usando Signal -->
  <div class="invitados">
    <button mat-raised-button color="primary" (click)="addInvitado()" [disabled]="(lista_invitados().length >= 1000)">
      <span i18n="@@web-inscripciones.anadir-invitado">Añadir invitado</span>
    </button>
    <ul>
      @for (invitado of lista_invitados(); track invitado.dni) {
        <li class="item-invitado">
          <div>
            <strong>{{invitado.dni}}</strong> - {{invitado.nombre}} {{invitado.apellido1}}
          </div>
          <nav>
            <button mat-icon-button color="primary" (click)="invitadoEdit(invitado.dni)">
              <mat-icon>edit_note</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="invitadoBorrar(invitado.dni)">
              <mat-icon>delete</mat-icon>
            </button>
          </nav>
        </li>
      }
    </ul>
  </div>
</section>

<footer>
  <div class="aviso-legal">
    <!-- Usamos el signal directamente con [ngModel] o (ngModelChange) si fuera signal pura de escritura -->
    <mat-checkbox [ngModel]="condiciones_legales()" (ngModelChange)="condiciones_legales.set($event)" color="primary">
      <span i18n="@@web-inscripciones.he-leido-y-acepto-las">He leído y acepto las</span>
    </mat-checkbox>
    <button mat-button color="primary" (click)="mostrarAvisoLegal()" i18n="@@web-inscripciones.condiciones-legales">condiciones legales</button>
  </div>

  <!-- Importe Total desde Computed Signal -->
  <h4><span i18n="@@web-inscripciones.importe-total">Importe total: {{ importe_total() }} €</span></h4>

  <nav>
    <!-- Lógica de habilitación simplificada gracias a los computed -->
    <button mat-raised-button color="primary" 
      [disabled]="!condiciones_legales() || form_inscripcion.invalid || (!es_colegiado() && !importe_total())" 
      (click)="realizarPago()">
      
      @if (!es_colegiado() || importe_total() > 0) {
        <span i18n="@@web-inscripciones.realizar-pago">Realizar pago</span>
      } @else {
        <span i18n="@@web-inscripciones.confirmar-inscripcion">Confirmar inscripción</span>
      }
    </button>
  </nav>
</footer>
